import React, { FC } from 'react';
import styles from './dateTimeField.module.scss';
import { DatePicker, TimePicker } from 'antd';
import { ErrorMessage, Field, FieldProps } from 'formik';
import Error from '../Error';
import moment, { Moment } from 'moment';
import { DatePickerProps } from 'enums/DatePickerEnum';

export interface DatePickerFieldProps {
  name: string;
  title?: string;
  placeholder?: string;
  value?: string | null;
  onChange: (value: Moment | null, dateString: string) => void;
  disabled?: boolean;
  format?: string;
  time?: boolean;
  rangePicker?: boolean;
}

const DatePickerField: FC<DatePickerFieldProps> = (
  props: DatePickerFieldProps
) => {
  const {
    name,
    title,
    placeholder,
    onChange,
    value,
    disabled,
    format = DatePickerProps.FORMAT,
    rangePicker,
  } = props;
  const { RangePicker } = DatePicker;

  return (
    <div className={styles.datePickerContainer}>
      <Field name={name}>
        {({ field }: FieldProps) => {
          return (
            <div>
              {title && <div>{title}</div>}
              {props.time ? (
                <TimePicker
                  value={value ? moment(value) : null}
                  onChange={onChange}
                />
              ) : rangePicker ? (
                <RangePicker
                  {...field}
                  picker="year"
                  disabled={disabled}
                  placeholder={
                    placeholder ? [placeholder, placeholder] : undefined
                  }
                />
              ) : (
                <DatePicker
                  {...field}
                  format={format}
                  disabled={disabled}
                  placeholder={placeholder}
                  onChange={onChange}
                  value={value ? moment(value) : null}
                />
              )}
              <ErrorMessage name={name}>
                {(message: string) => <Error message={message} />}
              </ErrorMessage>
            </div>
          );
        }}
      </Field>
    </div>
  );
};

export default DatePickerField;
